import React, { useEffect } from 'react';

import { useAuth } from 'hooks/selectors';
import Cookies from 'universal-cookie';

import { JWT, USER_COUNTRY_NAME } from '../../constants/Constants';

const cookies = new Cookies();

const WSChat = () => {
    let { jwt, userCountryName } = useAuth();
    const countryFieldId = '5256111385885';
    jwt = jwt || cookies.get(JWT);
    userCountryName = userCountryName || cookies.get(USER_COUNTRY_NAME);

    useEffect(() => {
        if (__isBrowser__ && typeof zE === 'function' && jwt) {
            zE('messenger', 'loginUser', function (callback) {
                callback(jwt);
            });
            if (userCountryName) {
                zE('messenger:set', 'conversationFields', [{ id: countryFieldId, value: userCountryName }]);
            }
        }
    }, [jwt]);

    return !jwt ? <div id="ze-snippet" /> : null;
};

export default WSChat;
